import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { semanticTheme } from '@tools/ui/dime';

export const BASE_PATH = '/dime-showcase';

export const COMPONENTS = [
  { label: 'Alert', path: `${BASE_PATH}/alert` },
  { label: 'AmountCard', path: `${BASE_PATH}/amount-card` },
  { label: 'Badge', path: `${BASE_PATH}/badge` },
  { label: 'Breadcrumbs', path: `${BASE_PATH}/breadcrumbs` },
  { label: 'Button', path: `${BASE_PATH}/button` },
  { label: 'ButtonDropdown', path: `${BASE_PATH}/button-dropdown` },
  { label: 'Checkbox', path: `${BASE_PATH}/checkbox` },
  { label: 'Divider', path: `${BASE_PATH}/divider` },
  { label: 'Drawer', path: `${BASE_PATH}/drawer` },
  { label: 'FilterGroup', path: `${BASE_PATH}/filter-group` },
  { label: 'FilterHeader', path: `${BASE_PATH}/filter-header` },
  { label: 'InsightLabel', path: `${BASE_PATH}/insight-label` },
  { label: 'Loader', path: `${BASE_PATH}/loader` },
  { label: 'Menu', path: `${BASE_PATH}/menu` },
  { label: 'Modal', path: `${BASE_PATH}/modal` },
  { label: 'Notification', path: `${BASE_PATH}/notification` },
  { label: 'NotificationBadge', path: `${BASE_PATH}/notification-badge` },
  { label: 'Pagination', path: `${BASE_PATH}/pagination` },
  { label: 'PaymentCard', path: `${BASE_PATH}/payment-card` },
  { label: 'Popover', path: `${BASE_PATH}/popover` },
  { label: 'RadioButton', path: `${BASE_PATH}/radio-button` },
  { label: 'RemovableTag', path: `${BASE_PATH}/removable-tag` },
  { label: 'RichTextEditor', path: `${BASE_PATH}/rich-text-editor` },
  { label: 'SegmentedControl', path: `${BASE_PATH}/segmented-control` },
  { label: 'Select', path: `${BASE_PATH}/select` },
  { label: 'StatCard', path: `${BASE_PATH}/stat-card` },
  { label: 'Switch', path: `${BASE_PATH}/switch` },
  { label: 'Tabs', path: `${BASE_PATH}/tabs` },
  { label: 'TagLabel', path: `${BASE_PATH}/tag-label` },
  { label: 'TextArea', path: `${BASE_PATH}/text-area` },
  { label: 'Tooltip', path: `${BASE_PATH}/tooltip` }
];

const NavPanel = styled.nav`
  width: 200px;
  min-width: 200px;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid ${semanticTheme.dime.colors.border.static};
  padding: 16px 0;
  background: ${semanticTheme.dime.colors.background.secondary};
`;

const NavHeader = styled.div`
  padding: 0 16px 12px;
  font-family: ${semanticTheme.dime.fonts.families.roboto};
  font-size: ${semanticTheme.dime.fonts.sizes.xs};
  font-weight: ${semanticTheme.dime.fonts.weights.semiBold};
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${semanticTheme.dime.colors.text.secondary};
`;

const NavItem = styled(Link)<{ $active: boolean }>`
  display: block;
  padding: 7px 16px;
  font-family: ${semanticTheme.dime.fonts.families.roboto};
  font-size: ${semanticTheme.dime.fonts.sizes.sm};
  text-decoration: none;
  color: ${({ $active }) =>
    $active
      ? semanticTheme.dime.colors.text.decorative4
      : semanticTheme.dime.colors.text.primary};
  background: ${({ $active }) =>
    $active ? semanticTheme.dime.colors.fill.decorative3 : 'transparent'};
  font-weight: ${({ $active }) =>
    $active
      ? semanticTheme.dime.fonts.weights.semiBold
      : semanticTheme.dime.fonts.weights.regular};
  border-left: 3px solid
    ${({ $active }) =>
      $active ? semanticTheme.dime.colors.text.decorative4 : 'transparent'};
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${semanticTheme.dime.colors.fill.decorative3};
    color: ${semanticTheme.dime.colors.text.decorative4};
  }
`;

export const ComponentNav: React.FC = () => {
  const { pathname } = useLocation();
  const hasMatch = COMPONENTS.some(({ path }) => pathname === path);

  return (
    <NavPanel>
      <NavHeader>Components</NavHeader>
      {COMPONENTS.map(({ label, path }, idx) => (
        <NavItem
          key={path}
          to={path}
          $active={pathname === path || (!hasMatch && idx === 0)}
        >
          {label}
        </NavItem>
      ))}
    </NavPanel>
  );
};
